import type {BaseQueryFn, FetchArgs, FetchBaseQueryError} from '@reduxjs/toolkit/query/react'
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {selectAuth} from '../features/authSlice'
import {RootState} from '../store'
import {API_END_POINTS} from './apiEndpoints'
import {baseUrl} from './baseUrl'
import {DynamicBaseQueryHeader} from './DynamicBaseQueryHeader'

export const FilesStorageApi = createApi({
  reducerPath: 'FilesStorageApi',
  // baseQuery: dynamicBaseQuery,
  baseQuery: DynamicBaseQueryHeader('FilesStorage'),
  endpoints: (builder) => ({
    getCCFeedfiles: builder.query({
      query: (params) => {
        return {
          url: `${API_END_POINTS.getCCFeedfiles}`,
          method: 'GET',
          params,
        }
      },
    }),
  }),
})

export const {
  useGetCCFeedfilesQuery,
} = FilesStorageApi
